import { render, staticRenderFns } from "./PropertyItemComponent.vue?vue&type=template&id=4db4653d"
import script from "./PropertyItemComponent.vue?vue&type=script&lang=js"
export * from "./PropertyItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports